import { pushDataTrackerEvent } from 'approot/shared/data-tracker/data-tracker-push';
import {
  EVENT_ACTION_DOWNLOAD,
  EVENT_CATEGORY_ACTIVITY_BUILDER,
  EVENT_TARGET_DOCUMENT_FILTERED_PAGES,
  EVENT_TARGET_DOCUMENT_PAGES,
  EVENT_TARGET_TYPE_DOCUMENT_TYPE,
} from '../data-tracker/data-events.constants';
import { LanguageCodes } from 'global/constants';

export function pushDownloadActivitiesEvent({
  pageNumbers,
  targetIdentifier,
  targetType,
  isPagesFiltered,
  version,
  language,
}: {
  pageNumbers: number[];
  targetType: string;
  targetIdentifier: number;
  isPagesFiltered: boolean;
  version: string | null;
  language: LanguageCodes;
}) {
  pushDataTrackerEvent(EVENT_CATEGORY_ACTIVITY_BUILDER, EVENT_ACTION_DOWNLOAD, {
    target_type: targetType,
    target_identifier: targetIdentifier,
    [EVENT_TARGET_TYPE_DOCUMENT_TYPE]: 'activities',
    [EVENT_TARGET_DOCUMENT_PAGES]: pageNumbers,
    [EVENT_TARGET_DOCUMENT_FILTERED_PAGES]: isPagesFiltered,
    version,
    language,
  });
}
